import React, { useState, useEffect, useRef } from 'react';
import { Radio, Space, TimePicker } from 'antd';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

const DurationSelector = ({ defaultDuration, onChange, value = null }) => {
    const [mode, setMode] = useState('default'); // 'default' or 'custom'
    const [customDuration, setCustomDuration] = useState(defaultDuration);
    const initialized = useRef(false);

// Convert seconds to a dayjs object that TimePicker can read
const secondsToTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return dayjs().startOf('day').hour(hours).minute(minutes).second(secs);
};

// Convert dayjs time object from TimePicker to total seconds
const timeToSeconds = (time) => {
  if (!time) return 0;
  return time.hour() * 3600 + time.minute() * 60 + time.second();
};


    // One-time initialization
    useEffect(() => {
        if (initialized.current) return;
        initialized.current = true;

        if (!value) {
            setMode('default');
            setCustomDuration(defaultDuration);
            return;
        }

        setMode(value.mode || 'default');
        if (value.mode === 'custom') {
            setCustomDuration(value.duration || defaultDuration);
        } else {
            setCustomDuration(defaultDuration);
        }
    }, []);

    // Notify parent on change
    useEffect(() => {
        onChange({
            mode,
            duration: mode === 'custom' ? customDuration : defaultDuration,
        });
    }, [mode, customDuration, defaultDuration, onChange]);

    return (
        <Radio.Group
            onChange={(e) => setMode(e.target.value)}
            value={mode}
            style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
        >
            <Radio value="default">Use existing durations</Radio>
            <Radio value="custom">
                <Space>
                    Replace with
                    <TimePicker
                        value={secondsToTime(customDuration)}
                        onChange={(time) => setCustomDuration(timeToSeconds(time))}
                        disabled={mode !== 'custom'}
                        format="HH:mm:ss"
                        allowClear={false}
                        showNow={false}
                        inputReadOnly
                        style={{ width: 120 }}
                    />
                    (h:m:s)
                </Space>
            </Radio>
        </Radio.Group>
    );
};

export default DurationSelector;
